import * as React from "react"
import { all_locations_object } from "../Constants"
import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import Grid from '@mui/material/Grid2';
import DocumentTitle from "../Utils/DocumentTitle"
import { useTrackedDarkMode, useTrackedLocation } from "./UserState";
import Income from "./Reports/Metrics/Income";
import { useLocations } from "./ReactQuery/QueryLocations";
import { MetricContainer } from "./Reports/Metrics/MetricComponents";
import TechnicianTimeWorked from "./Reports/Metrics/TechnicianTimeWorked";
import ServiceOrdersCreated from "./Reports/Metrics/ServiceOrdersCreated";
import ServiceOrdersClosed from "./Reports/Metrics/ServiceOrdersClosed";
import ServiceOrderServiceWorkloadMetric from "./Reports/Metrics/ServiceOrderServiceWorkloadMetric";
import TimeInStoreClosed from "./Reports/Metrics/TimeInStoreClosed";
import TimeInStoreOpen from "./Reports/Metrics/TimeInStoreOpen";
import ServiceOrdersStale from "./Reports/Metrics/ServiceOrdersStale";
import ServicePartsStale from "./Reports/Metrics/ServicePartsStale";

export default function Dashboard(props) {
    DocumentTitle('Dashboard')
    const [darkMode,] = useTrackedDarkMode();
    const { data: locations, isLoading: loadingLocations } = useLocations();
    const [selectedLocation,] = useTrackedLocation();
    const [daysBack, setDaysBack] = React.useState(7) // Default to 7 days
    const borderColor = darkMode ? '#FFF' : 'rgba(0, 0, 0, 0.87)'

    const selectedLocations = selectedLocation.id !== all_locations_object.id ? [selectedLocation] : locations

    return (
        <Box sx={{
            width: '100%',
            height: '100%'
        }}>
            <FormControl>
                <InputLabel id="metrics-days-back">Days Back</InputLabel>
                <Select
                    labelId="metrics-days-back"
                    label="Days Back"
                    value={daysBack}
                    onChange={(e) => setDaysBack(e.target.value)}
                    sx={{
                        minWidth: '200px',
                        marginBottom: 2,
                        borderRadius: '8px'
                    }}
                >
                    <MenuItem value={1}>
                        Yesterday
                    </MenuItem>
                    <MenuItem value={7}>
                        7 Days
                    </MenuItem>
                    <MenuItem value={14}>
                        14 Days
                    </MenuItem>
                    <MenuItem value={30}>
                        30 Days
                    </MenuItem>
                </Select>
            </FormControl>
            {loadingLocations && <CircularProgress />}
            {!loadingLocations &&
                <Grid container spacing={1} sx={{
                    width: '100%',
                    minWidth: '100%'
                }} columns={{ xs: 3, sm: 6, md: 6, lg: 12, xl: 12 }}>
                    <Grid container size={3} spacing={1} direction={'column'}>
                        <Grid>
                            <MetricContainer borderColor={borderColor}>
                                <Income selectedLocations={selectedLocations} days_back={daysBack} />
                            </MetricContainer>
                        </Grid>
                        <Grid>
                            <MetricContainer borderColor={borderColor}>
                                <TechnicianTimeWorked selectedLocations={selectedLocations} days_back={daysBack} />
                            </MetricContainer>
                        </Grid>
                    </Grid>
                    <Grid container size={3} spacing={1} direction={'column'}>
                        <Grid>
                            <MetricContainer borderColor={borderColor}>
                                <ServiceOrdersCreated selectedLocations={selectedLocations} days_back={daysBack} />
                            </MetricContainer>
                        </Grid>
                        <Grid>
                            <MetricContainer borderColor={borderColor}>
                                <ServiceOrdersClosed selectedLocations={selectedLocations} days_back={daysBack} />
                            </MetricContainer>
                        </Grid>
                    </Grid>
                    <Grid size={6} container spacing={1} direction={'column'}>
                        <Grid sx={{ height: '100%' }}>
                            <MetricContainer borderColor={borderColor}>
                                <ServiceOrderServiceWorkloadMetric selectedLocations={selectedLocations} />
                            </MetricContainer>
                        </Grid>
                    </Grid>
                    <Grid size={3}>
                        <MetricContainer borderColor={borderColor}>
                            <TimeInStoreOpen selectedLocations={selectedLocations} days_back={daysBack} />
                        </MetricContainer>
                    </Grid>
                    <Grid size={3}>
                        <MetricContainer borderColor={borderColor}>
                            <TimeInStoreClosed selectedLocations={selectedLocations} days_back={daysBack} />
                        </MetricContainer>
                    </Grid>
                    <Grid size={3}>
                        <MetricContainer borderColor={borderColor}>
                            <ServiceOrdersStale selectedLocations={selectedLocations} days_back={daysBack} />
                        </MetricContainer>
                    </Grid>
                    <Grid size={3}>
                        <MetricContainer borderColor={borderColor}>
                            <ServicePartsStale selectedLocations={selectedLocations} days_back={daysBack} />
                        </MetricContainer>
                    </Grid>
                </Grid>
            }
        </Box>
    )
}